import React from 'react';
import { Box, Divider } from '@mui/material';
import PoweredByCoretava from '@gamiphy/icons/PoweredByCoretava';
import { observer } from 'mobx-react';
import { Pages, UiStore } from '@gamiphy/loyalty-station-desktop/store/ui';
import Home from '@gamiphy/loyalty-station-desktop/pages/cashbackProgram/HomePage';
import Survey from '@gamiphy/loyalty-station-desktop/pages/cashbackProgram/SurveyPage';
import { CampaignUserStore } from '@gamiphy/loyalty-station-desktop/store/campaignUsers';
import Header from './components/Header';

const LoggedIn: React.FC = () => {
  const content = React.useMemo(() => {
    switch (UiStore.currentPage) {
      case Pages.home:
        return <Home />;
      case Pages.survey:
        return CampaignUserStore.surveyCampaignUser && <Survey campaignUser={CampaignUserStore.surveyCampaignUser} />;
      default:
        return undefined;
    }
  }, [UiStore.currentPage, CampaignUserStore.surveyCampaignUser]);

  return (
    <Box display="flex" flexDirection="column" height="100%" bgcolor="#F9F9F9">
      <Header />
      <Box
        overflow="auto"
        flexGrow={1}
        sx={{
          overflowX: 'hidden',
          '&::-webkit-scrollbar': {
            display: 'none',
            msOverflowStyle: 'none',
          },
          scrollbarWidth: 'none',
        }}
      >
        {content}
      </Box>
      <Divider />
      <Box textAlign="center" height={49} display="flex" alignItems="center" justifyContent="center" p={2}>
        <PoweredByCoretava color="#ADADAD" textColor="#ADADAD" width={176} />
      </Box>
    </Box>
  );
};

export default observer(LoggedIn);
